import {Component, Injector, OnInit} from '@angular/core';
import {BaseNewComponents} from '../../base-new-components';

interface IPartnerHotels {
  id: number;
  source: string;
  alt: string;
}
@Component({
  selector: 'app-partner-hotels',
  templateUrl: './partner-hotels.component.html',
  styleUrls: ['./partner-hotels.component.sass']
})
export class PartnerHotelsComponent extends BaseNewComponents implements OnInit {

  responsiveOptions = [
    {
      breakpoint: '1024px',
    },
    {
      breakpoint: '768px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  partner: IPartnerHotels[] = [
    {id: 1, source: 'assets/img/view/partners-hotels/logos_accor.png', alt: 'Accor'},
    {id: 2, source: 'assets/img/view/partners-hotels/logos_atlantica.png', alt: 'Atlantica'},
    {id: 3, source: 'assets/img/view/partners-hotels/logos_bestweter.png', alt: 'Bestweter'},
    {id: 4, source: 'assets/img/view/partners-hotels/logos_bluetree.png', alt: 'Bluetree'},
    {id: 5, source: 'assets/img/view/partners-hotels/logos_hilton.png', alt: 'Hilton'},
    {id: 6, source: 'assets/img/view/partners-hotels/logos_ihg.png', alt: 'IHG'},
    {id: 7, source: 'assets/img/view/partners-hotels/logos_intercity.png', alt: 'Intercity'},
    {id: 8, source: 'assets/img/view/partners-hotels/logos_lagheto.png', alt: 'Lagheto'},
    {id: 9, source: 'assets/img/view/partners-hotels/logos_louvre.png', alt: 'Louvre'},
    {id: 10, source: 'assets/img/view/partners-hotels/logos_melia.png', alt: 'Melia'},
    {id: 11, source: 'assets/img/view/partners-hotels/logos_taua.png', alt: 'Taua'},
    {id: 12, source: 'assets/img/view/partners-hotels/logos_vilagale.png', alt: 'Vilagale'},
    {id: 13, source: 'assets/img/view/partners-hotels/logos_wyndham.png', alt: 'Wyndham'},
  ];

  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
  }

}
